import { pocActionTypes } from './Poc.actionTypes';

const initialState = {
  loading: false,
  calculatedTimelog: {
    appTimeTrackMap: {},
    screenShots: [],
    totalTimeTracked: '',
  },
  applicationInfo: {},
  attendanceData: [],
};

export default function pocReducer(state = initialState, action) {
  switch (action.type) {
    case pocActionTypes.SET_POC_DATA:
      return { ...state, calculatedTimelog: action.payload };
    case pocActionTypes.SET_APPLICATION_INFO:
      return { ...state, applicationInfo: action.payload };
    case pocActionTypes.SET_LOADING:
      return { ...state, loading: action.payload };
    case pocActionTypes.SET_ATTENDANCE_DATA:
      return { ...state, attendanceData: action.payload };
    case pocActionTypes.SET_USER_TOKEN_OPTIONS:
      return {
        ...state,
        userTokenOptions: action.payload,
      };
    default:
      return state;
  }
}
